import { gql, useLazyQuery } from "@apollo/client";
import { getErrors } from "../../utils";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { MetricTrendModel, PermitMetricQueryInput } from "./getPermitsCountByStatesMetric";

export interface PermitRequestApprovalStatsMetric {
  permitRequestApprovalStatsMetric: {
    __typename: "MetricApprovalStats";
    value: number;
    previousValue: number | null;
    delta: number | null;
    deltaPercentage: number | null;
    trend: MetricTrendModel;
    approved: number;
    rejected: number;
  };
}

export interface PermitRequestApprovalStatsMetricVariables {
  query: PermitMetricQueryInput;
}

export const GET_PERMIT_REQUEST_APPROVAL_STATS_METRIC = gql`
  query PermitRequestApprovalStatsMetric($query: PermitMetricQueryInput!) {
    permitRequestApprovalStatsMetric(query: $query) {
      value
      previousValue
      delta
      deltaPercentage
      trend {
        key
        name
      }
      approved
      rejected
    }
  }
`;

export function useGetPermitRequestApprovalStatsMetric() {
  const [getPermitRequestApprovalStatsMetric, { loading, error, data }] = useLazyQuery<
    PermitRequestApprovalStatsMetric,
    PermitRequestApprovalStatsMetricVariables
  >(GET_PERMIT_REQUEST_APPROVAL_STATS_METRIC, {
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  return {
    getPermitRequestApprovalStatsMetric,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}

